import { httpService } from '@/services/HttpService';

class FirewallService {
  getFirewallVersions(workspaceId: number, regionId: number): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/regions/${regionId}/firewalls`);
  }
  getFirewallRules(workspaceId: number, regionId: number, id: any): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/regions/${regionId}/firewalls/${id}`);
  }
  updateFirewall(workspaceId: number, regionId: number, data: any): Promise<any> {
    return httpService.post(`workspaces/${workspaceId}/regions/${regionId}/firewalls`, data);
  }
}

export const firewallService = new FirewallService();
